<template>
  <div>
    <div class="divTable">
      <div class="row divHeader">
        <div class="col-6">{{ col }}</div>
        <div class="col-6">Fecha</div>
      </div>
      <div class="row divBody">
        <div class="col-6">{{ row.dato }}</div>
        <div class="col-6">{{ row.fecha }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    col: String,
    row: Object,
    rowObjetivoPartida: Object,
    type: String
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.divTable {
  border-radius: 5px;
  border: solid 2px grey;
  margin: 0px;
  margin-top: 30px;
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  .divHeader {
    border-bottom: solid 2px grey;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.11px;
    color: #002f6c;
    padding: 10px;
  }
  .divBody {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.12px;
    color: #2b2a2a;
    padding: 10px;
    height: 97px;
    align-content: center;
  }
}
</style>
